export enum DeepLinkRoutes
{
    LOG_IN = "/login-end",
    CREATE_ACCOUNT = "/create-account-end",
    ACCOUNT_LOGIN = "/account-login",
    MESSAGE = "/message",
    ERROR = "/error"
}